export enum CustomTokenLoginParams {
  CUSTOM_TOKEN = "token",
  REDIRECT_TO = "redirectTo",
}
